import { IS_ETS_NEXT } from '@/utils/constants';
import {
  getGoGovModules,
  getInternalFeatures,
  getStandardModules,
} from '@/utils/hubPermissions/registry';

export const etsNextLockedDownModules = [
  'reports',
  'spendManagement',
  'travelSpend',
  'dataManagement',
  'tickettrak',
  'travelAuthorization',
  'tableConnector',
  'ibankReporting',
];

export const etsNextLockedDownFeatures = [
  'qcMailTicketingOperations',
  'qcMailTicketingDataInsights',
  'cisInternalDynamicReporting',
];

function excludeHidden(modules) {
  return modules.map((mod) => ({
    ...mod,
    features: mod.features.filter((f) => !f.hidden),
  }));
}

export function getProductsFeatures() {
  let features = excludeHidden(getStandardModules());
  if (IS_ETS_NEXT) {
    features = excludeHidden(getGoGovModules()).concat(features);
    features = features
      .filter((product) => !etsNextLockedDownModules.includes(product.key))
      .map((product) => ({
        ...product,
        features: product?.features?.filter(
          (feature) => !etsNextLockedDownFeatures.includes(feature.key)
        ),
      }));
  }

  return features;
}

export function getInternalOnlyFeatures() {
  let features = getInternalFeatures();
  if (IS_ETS_NEXT)
    features = features.filter(
      (product) => !etsNextLockedDownFeatures.includes(product.key)
    );
  return features;
}

export function getAllModuleKeys() {
  const productsFeatures = getProductsFeatures();

  let keys = productsFeatures.map((product) => product.key);
  keys.push('cisInternal');

  return keys;
}

// Recursively collects all feature keys from products and internal-only features.
export function getAllFeatureKeys() {
  const productsFeatures = getProductsFeatures();
  const internalOnlyFeatures = getInternalOnlyFeatures();

  function collectFeatureKeys(features) {
    let keys = [];
    features.forEach((feature) => {
      if (feature && feature.key) {
        keys.push(feature.key);
        if (Array.isArray(feature.features) && feature.features.length > 0) {
          keys = keys.concat(collectFeatureKeys(feature.features));
        }
      }
    });
    return keys;
  }

  let keys = productsFeatures.reduce((acc, product) => {
    return acc.concat(collectFeatureKeys(product.features));
  }, []);

  keys = keys.concat(collectFeatureKeys(internalOnlyFeatures));

  return keys;
}

export function getAllSubFeatureKeys() {
  const productsFeatures = getProductsFeatures();
  const internalOnlyFeatures = getInternalOnlyFeatures();

  let keys = productsFeatures.reduce((acc, product) => {
    product.features.forEach((feature) => {
      if (feature.subFeatures) {
        feature.subFeatures.forEach((subFeature) => {
          acc.push(subFeature.key);
        });
      }
    });
    return acc;
  }, []);

  internalOnlyFeatures.forEach((feature) => {
    if (feature.subFeatures) {
      feature.subFeatures.forEach((subFeature) => {
        keys.push(subFeature.key);
      });
    }
  });

  return keys;
}
